module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trainers"
  }, [_c('div', {
    staticClass: "trainers__content"
  }, [_c('responsive', [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', {
    staticStyle: {
      "min-width": "60px"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Trainer name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Nickname")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "300px"
    }
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tbody', _vm._l((_vm.trainers), function(trainer, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(trainer.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(((trainer.firstName) + " " + (trainer.lastName))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(trainer.nickname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(trainer.user ? trainer.user.email : ''))]), _vm._v(" "), _c('th', [_c('v-button', {
      attrs: {
        "to": ("/admin/trainers/edit/" + (trainer.id)),
        "size": "small",
        "disabled": _vm.disabled
      }
    }, [_vm._v("Edit")]), _vm._v(" "), _c('v-button', {
      attrs: {
        "color": "danger",
        "size": "small",
        "disabled": _vm.disabled
      },
      nativeOn: {
        "click": function($event) {
          _vm.removeTrainer(trainer.id)
        }
      }
    }, [_vm._v("Remove")])], 1)])
  }))])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "page-count": _vm.totalPages,
      "click-handler": _vm.handlePaginate,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "container-class": 'pagination',
      "page-class": 'pagination__item'
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31d3063e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/TrainerManager/All.vue
// module id = 1656
// module chunks = 1